import * as React from 'react';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

type ErrorMessageProps = {
  id: string;
  children: React.ReactNode;
  show: boolean;
};

const ErrorMessage: React.FunctionComponent<ErrorMessageProps> = ({
  children,
  id,
  show,
}) => {
  const { captiontextErrorNone: errorTextStyle } = useTheme();

  if (!show) return null;

  return (
    <p
      id={id}
      style={{
        ...errorTextStyle,
        margin: '.25rem 0 0 0',
      }}
    >
      {children}
    </p>
  );
};

export default withThemeProvider(ErrorMessage, {
  themeTokens: ['captiontextErrorNone'],
});
